import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Trash2 } from 'lucide-react';
import { StatusBadge } from '../StatusBadge';

export function TransactionList({ transactions, onMarkPaid, onDelete }) {
  const navigate = useNavigate();

  if (transactions.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3">
      {transactions.map((txn) => (
        <div
          key={txn.id}
          className={`bg-surface border rounded-xl p-4 ${
            txn.type === 'expense' && txn.tax_deductible 
              ? 'border-primary/30 bg-primary/5' 
              : 'border-border'
          }`}
          data-testid={`transaction-card-${txn.id}`}
        >
          <div className="flex items-start justify-between mb-2">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <h3 className="font-medium text-foreground">{txn.description}</h3>
                {txn.invoice_status && <StatusBadge status={txn.invoice_status} />}
                {txn.type === 'expense' && txn.tax_deductible && (
                  <span className="text-xs bg-primary/10 text-primary px-2 py-0.5 rounded-full border border-primary/20">
                    Tax Deductible
                  </span>
                )}
              </div>
              <button
                onClick={() => navigate(`/clients/${txn.client_id}`)}
                className="text-sm text-text-secondary hover:text-primary transition-colors"
              >
                {txn.client_name}
              </button>
              <div className="flex items-center gap-3 mt-2">
                <span className="text-xs text-text-muted capitalize">{txn.type}</span>
                <span className="text-xs text-text-muted">{txn.date}</span>
                {txn.due_date && txn.type === 'invoice' && (
                  <span className="text-xs text-text-muted">Due: {txn.due_date}</span>
                )}
              </div>
            </div>
            <div className="flex flex-col items-end gap-2">
              <div className="flex items-center gap-1">
                <span className={`text-lg font-bold ${txn.type === 'expense' ? 'text-alert' : 'text-success'}`}>
                  {txn.type === 'expense' ? '-' : '+'}${txn.amount.toFixed(2)}
                </span>
                {onDelete && (
                  <button
                    onClick={() => onDelete(txn)}
                    className="p-1.5 -mr-1 text-text-muted hover:text-alert hover:bg-alert/10 rounded-lg transition-colors"
                    aria-label={`Delete transaction ${txn.description}`}
                    data-testid={`delete-transaction-${txn.id}`}
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                )}
              </div>
              {txn.type === 'invoice' && txn.invoice_status === 'unpaid' && (
                <button
                  onClick={() => onMarkPaid(txn.id)}
                  className="text-xs bg-success/10 text-success px-2 py-1 rounded border border-success/20 hover:bg-success/20 transition-colors"
                  data-testid={`mark-paid-${txn.id}`}
                >
                  Mark Paid
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
